/**
 * Encode navigation targets before assigning them to `location.href`.
 */
export function escapeHref(value: string) {
  return encodeURI(value)
}
